import { render, staticRenderFns } from "./jinong-trade.html?vue&type=template&id=551d63ac&scoped=true&external"
import script from "./jinong-trade.js?vue&type=script&lang=js&external"
export * from "./jinong-trade.js?vue&type=script&lang=js&external"
import style0 from "./jinong-trade.scss?vue&type=style&index=0&id=551d63ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d63ac",
  null
  
)

export default component.exports